module.exports = __webpack_public_path__ + "static/img/20007 (3).e280b41.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20007 (3).webp
// module id = vHP+
// module chunks = 14